"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AGENT_CLIENT_TYPE = void 0;
exports.USER_AGENT_CLIENT_TYPE = {
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
    DESKTOP: 'DESKTOP'
};
//# sourceMappingURL=userAgentClientType.js.map